var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"lead"},[_c('stemble-latex',{attrs:{"content":_vm.invalidFeedback}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }